import { PageHeaderLayout } from "@homebound/beam";
import { BidContractsTableV2 } from "src/components/bid-contracts/BidContractsTableV2";

export function ProjectBidContractsPage() {
  return (
    <PageHeaderLayout pageHeader={{ title: "Bid Contracts" }}>
      <BidContractsTableV2 />
    </PageHeaderLayout>
  );
}
